import TitleSection from "../../components/pageComponents/titleSection/TitleSection";
import React from "react";

const AcademicsLayout = () => {
  return (
    <div>
      <div id="schooltitle">
        <TitleSection />
      </div>
      <h1>Academics</h1>
    </div>
  );
};

export default AcademicsLayout;
